export default class LangSwitcherEnum {
    static BODY = 'body'
    static LANG_SWITCHER = '[data-element="lang-switcher"]'
    static LANG_SWITCHER_LIST = '[data-element="lang-switcher-list"]'
    static LANG_SWITCHER_ITEM = '[data-element="lang-switcher-item"]'
    static LANG_SWITCHER_TRIGGER = '[data-element="lang-switcher-trigger"]'
}
